import { __decorate } from "tslib";
import { customElement } from '@microsoft/fast-element';
import { GridProGenesisDatasource } from '../grid-pro-genesis-datasource';
/**
 * The Genesis Datasource element, for client-side | CSRM-compatible data fetching and used exclusively by the GridPro element.
 * @remarks Only supports Client-Side Row Model.
 * @public
 */
let GridProClientSideDatasource = class GridProClientSideDatasource extends GridProGenesisDatasource {
};
GridProClientSideDatasource = __decorate([
    customElement({
        name: 'grid-pro-client-side-datasource',
    })
], GridProClientSideDatasource);
export { GridProClientSideDatasource };
